import Vue from 'vue'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import OtpInput from '@bachdgvn/vue-otp-input'
Vue.component('v-otp-input', OtpInput)
export default {
  name: 'earningsModal',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      mutableActived: this.activated
    }
  },
  props: ['activated', 'closeEarningsModal'],
  methods: {
    handleFileChange (e) {
      this.$emit('input', e.target.files[0])
    },
    closeJobOffer () {
      this.closeEarningsModal(true)
      this.mutableActived = !this.mutableActived
      this.$el.blur()
    }
  },
  watch: {
    activated (oldVal, newVal) {
      if (oldVal !== newVal && oldVal !== null) {
        this.mutableActived = !this.mutableActived
        this.$el.tabIndex = 1
        this.$nextTick(function () {
          this.$el.focus()
        })
      }
    }
  }
}
